<!-- @format -->

<register-company-complete-tag>
  <div class="contents">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_application">法人申請の完了</h1>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="{ routes.makePath('top-tag') }" class="home">ホーム</a>
          </li>
          <li class="breadcrumb-item">
            <a onclick="{ back }">法人申請</a>
          </li>
          <li class="breadcrumb-item">法人申請の完了</li>
        </ul>
      </div>
      <!--/.container_heading-->

      <div class="contents_block detail">
        <p class="align-c">
          法人利用申請が完了しました。
          <br />
          入力された情報をもとに審査を行っておりますので今しばらくお待ちください。
        </p>
        <p class="notice align-c">
          ※審査結果に関しては申請されたアカウントメールアドレスに届きます。
        </p>

        <ul class="link_list">
          <li class="link_list-item">
            <a href="{ routes.makePath('top-tag') }">ホームに戻る</a>
          </li>
        </ul>
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <script>
    import routes from "@model/menu-routes.js";

    export default {
      onBeforeMount() {
        this.routes = routes;
      },
      back(e) {
        this.props.fetchApplyingData();
      },
    };
  </script>
</register-company-complete-tag>
